import { useEffect } from "react";
import type { PageConfig } from "../../adminNext/screens/content-sections/editor/types";

interface CMSPageSEOProps {
  seo: PageConfig["seo"] | null;
  socialSharing: PageConfig["social_sharing"] | null;
  pathname: string;
}

function setMetaTag(property: string, content: string | null, isOg = false) {
  if (!content) return;
  const attr = isOg ? "property" : "name";
  let el = document.querySelector(`meta[${attr}="${property}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, property);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setLinkTag(rel: string, href: string) {
  let el = document.querySelector(`link[rel="${rel}"]`) as HTMLLinkElement | null;
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export function CMSPageSEO({
  seo,
  socialSharing,
  pathname,
}: CMSPageSEOProps): null {
  useEffect(() => {
    if (!seo && !socialSharing) return;

    const prevTitle = document.title;

    if (seo?.title) {
      document.title = seo.title;
    }

    setMetaTag("description", seo?.description ?? null);
    setMetaTag("og:title", socialSharing?.og_title ?? seo?.title ?? null, true);
    setMetaTag(
      "og:description",
      socialSharing?.og_description ?? seo?.description ?? null,
      true,
    );
    setMetaTag("og:url", `${window.location.origin}${pathname}`, true);

    if (seo?.no_index) {
      setMetaTag("robots", "noindex, nofollow");
    }

    const canonicalUrl = seo?.canonical_url ?? `${window.location.origin}${pathname}`;
    setLinkTag("canonical", canonicalUrl);

    return () => {
      document.title = prevTitle;
    };
  }, [seo, socialSharing, pathname]);

  return null;
}
